export default "__VITE_ASSET__CUcT3e2k__"